<template>
  <div style="width: 100%;">
    <v-row>
      <v-col>
        <v-container>
          <v-row>
            <v-col class="d-flex flex-row align-center">
              <h1>{{this.plural}}</h1>
              <!-- <span>
                <VueSignaturePad width="500px" height="500px" ref="signaturePad" :options="signaturePadOptions"/>
                <div>
                  <button @click="save">Save</button>
                  <button @click="undo">Undo</button>
                  <button @click="clear">Clear</button>
                </div>
              </span> -->
              <v-btn fab x-small class="ml-2" color="success" @click="openCreateAppointmentDialog()"><v-icon>mdi-plus</v-icon></v-btn>
              <v-btn small class="ml-2" color="info" @click="$router.push('/appointments/followUp')">Customers Follow Up</v-btn>
              <v-progress-circular
                  indeterminate
                  color="green"
                  v-if="loader"
                  style="margin-left: 10px;"
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                  :headers="headers"
                  :items="allData"
                  :options.sync="options"
                  :server-items-length="pagination.dataCount"
                  :loading="pagination.loading"
                  :items-per-page="15"
                  :footer-props="{
                    itemsPerPageOptions: pagination.pageSizeOptions
                  }"
                  class="elevation-1"
                  @click:row="rowClick"
              >
                <template v-slot:top>
                  <v-text-field
                      v-model="appointmentSearch"
                      label="Search..."
                      class="mx-4"
                      @input="searchAppointments"
                      clearable
                  ></v-text-field>
                </template>
                <template v-slot:item.dealtWithBy="{ item }">
                  <span>{{lookupUsername(item.dealtWithBy || item.createdBy)}}</span>
                </template>
                <template v-slot:item.appointmentType="{ item }">
                  <span>{{appointmentTypes.find(x => x.id===item.appointmentType)?appointmentTypes.find(x => x.id===item.appointmentType).name:'Unknown'}}</span>
                </template>
                <template v-slot:item.customerName="{ item }">
                  <span>{{item.Customer?(item.Customer.firstName+' '+item.Customer.lastName):'None'}}</span>
                </template>
                <template v-slot:item.customerPhone="{ item }">
                  <span>{{item.Customer?item.Customer.phone:'None'}}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip :color="utils.getAppointmentStatusColor(item.status)">{{utils.parseAppointmentStatus(item.status)}}</v-chip>
                </template>
                <template v-slot:item.scheduledFor="{ item }">
                  <span>{{utils.customFormatDate(item.scheduledFor)}}</span>
                </template>
                <template v-slot:item.cca="{ item }">
                  <span v-if="item.metadata.confirmationCallAttempted">YES</span>
                  <span v-else>NO</span>
                </template>
                <template v-slot:item.ccs="{ item }">
                  <span v-if="item.metadata.confirmationCallSuccess">YES</span>
                  <span v-else>NO</span>
                </template>
                <template v-slot:item.agreedToTerms="{ item }">
                  <span v-if="item.agreedToTerms==true">YES</span>
                  <span v-else>NO</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="createAppointmentDialog.isOpen" max-width="1600">
      <v-card>
        <v-card-title><h2 class="pt-3">Create New Appointment</h2></v-card-title>
        <v-card-text class="pa-5">
          <v-form class="d-flex flex-row" style="width: 100%;">
            <span style="width:60%;">
              <v-card outlined>
                <v-card-title>
                  <h3>Customer Information</h3>
                </v-card-title>
                <v-card-text class="d-flex flex-column">
                  <span class="d-flex flex-row">
                    <v-text-field :loading="findCustomerByPhoneLoader" ref="customerPhone" v-model="createAppointmentDialog.appointment.customerPhone" @keyup="findCustomerByPhone" label="Phone" outlined></v-text-field>
                    <v-text-field class="ml-3" outlined label="Customer Name" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerName" @change="updateAppointment()"/>
                  </span>
                  <span class="d-flex flex-row" v-if="newCustomer.suggestedMatches && newCustomer.suggestedMatches.length > 0">
                    <v-btn fab class="mr-2" x-small color="error" @click="clearCustomerSuggestions"><v-icon>mdi-close</v-icon></v-btn>
                    <div style="width: 100%; height: 100%;">
                      <v-chip class="mr-1 mb-2" v-for="suggestion in newCustomer.suggestedMatches" :key="suggestion.id" @click="setCustomer(suggestion)">
                        <b style="font-size: 12px;">{{suggestion.firstName}} {{suggestion.lastName}} | {{suggestion.phone}}</b>
                      </v-chip>
                    </div>
                  </span>
                  <span class="d-flex flex-row">
                    <v-text-field class="" outlined label="Customer Email" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerEmail" @change="updateAppointment()"/>
                    <v-text-field class="ml-3" outlined label="Address Line 1" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerLine1" @change="updateAppointment()"/>
                  </span>
                  <span class="d-flex flex-row">
                    <v-text-field class="" outlined label="Address Line 2" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerLine2" @change="updateAppointment()"/>
                    <v-text-field class="ml-3" outlined label="Address City" :disabled="createAppointmentDialog.appointment.customerId!=''" v-model="createAppointmentDialog.appointment.customerCity" @change="updateAppointment()"/>
                  </span>
                  <span>
                    <v-menu
                        :close-on-content-click="false"
                        :nudge-right="0"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="utils.parseDate(createAppointmentDialog.appointment.weddingDate,2)"
                            label="Wedding Date"
                            readonly
                            outlined
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                        />
                      </template>
                      <v-date-picker
                          @change="updateAppointment()"
                          v-model="createAppointmentDialog.appointment.weddingDate"
                      />
                    </v-menu>
                  </span>
                </v-card-text>
              </v-card>
              <v-card class="mt-3" outlined>
                <v-card-title>
                  <h3>Reason for Appointment</h3>
                </v-card-title>
                <v-card-text>
                  <span class="d-flex flex-row">
                    <span class="mr-3" v-for="intention in intentions" :key="intention.id">
                      <v-checkbox @change="updateAppointment()" v-model="createAppointmentDialog.appointment.intentions" :label="intention.name" :value="intention.id"/>
                    </span>
                  </span>
                  <span class="d-flex flex-row">
                    <v-text-field outlined label="Max Budget" @change="updateAppointment()" type="number" v-model="createAppointmentDialog.appointment.budget"/>
                    <v-text-field outlined class="ml-3" label="Number of Persons" @change="updateAppointment()" type="number" v-model="createAppointmentDialog.appointment.occupants"/>
                    <v-select
                      :items="genders"
                      item-text="name"
                      item-value="id"
                      label="Gender"
                      outlined
                      class="ml-3"
                      v-model="createAppointmentDialog.appointment.gender"
                    />
                  </span>
                  <v-textarea label="Notes" @change="updateAppointment()" v-model="createAppointmentDialog.appointment.notes" dense outlined/>
                  <span class="d-flex flex-row">
                      <v-checkbox class="mr-3" v-model="createAppointmentDialog.appointment.isWalkIn" @change="updateAppointment()" label="Walk-In"/>
                      <v-checkbox class="mr-3" v-model="createAppointmentDialog.appointment.metadata.force" @change="updateAppointment()" label="Force Create"/>
                      <v-checkbox class="mr-3" v-model="createAppointmentDialog.appointment.metadata.firstAppointment" @change="updateAppointment()" label="First Appointment"/>
                  </span>
                </v-card-text>
              </v-card>
            </span>
            <div class="d-flex flex-column ml-3" style="background-color: rgba(0,0,0,0); width:40%">
              <v-card outlined>
                <v-card-title>
                  <h3>Select Date & Time</h3>
                </v-card-title>
                <v-card-text>
                  <v-date-picker full-width v-model="createAppointmentDialog.appointment.scheduledForDate" @change="getDateSchedule"/>
                </v-card-text>
              </v-card>
              <v-card class="mt-3" outlined>
                <v-card-title>
                  <h3 >Available Appointments</h3>
                </v-card-title>
                <v-card-text>
                  <v-progress-circular
                      indeterminate
                      color="green"
                      v-if="dateScheduleLoader"
                      style="margin-left: 10px;"
                  ></v-progress-circular>
                  <h3>{{ createAppointmentDialog.exemptionLabel }}</h3>              
                  <span class="d-flex flex-column" v-if="dateSchedule && dateSchedule.length > 0">
                    <v-radio-group v-model="createAppointmentDialog.appointment.scheduledForTime" @change="setAppointmentBlock">
                      <v-radio
                        v-for="(block,index) in dateSchedule"
                        :key="index"
                        :value="block"
                        :disabled="(!block.available||dateScheduleLoader) && !createAppointmentDialog.appointment.metadata.force"
                      >
                        <template v-slot:label>
                          <span v-if="block.available || createAppointmentDialog.appointment.metadata.force" style="width: 100%; height: 100%;" class="success mb-1 pa-2">
                            <div>{{ utils.convert24HourTime(block.time) }}</div>
                          </span>
                          <span v-else style="width: 100%; height: 100%;" class="warning my-1 pa-2">
                            <div> <strike>{{ block.time }}</strike> </div>
                          </span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </span>
                  <span v-else>Select a date.</span>
                </v-card-text>
              </v-card>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAppointmentDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!createAppointmentDialog.isValid" @click="saveAppointment" :loading="createAppointmentDialog.isLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  import utils from '../../plugins/helpers'
  import _ from "lodash";

  export default {
    data () {
      return {
        signaturePadOptions: {
          penColor: 'black'
        },
        utils: utils,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        findCustomerByPhoneLoader: false,
        newCustomer: {addresses: [], suggestedMatches: []},
        snackObj: {
          color: '',
          text: ''
        },
        rules: {
          required: [v => !!v || 'This field is required.'],
        },
        headers: [
          { text: 'ID', value: 'id' },
          {text: 'Customer Name', sortable: true, value: 'customerName'},
          {text: 'Customer Phone', sortable: false, value: 'customerPhone'},
          {text: 'Appointment Date', sortable: true, value: 'scheduledFor'},
          {text: 'Appointment Type', sortable: true, value: 'appointmentType'},
          {text: 'Status', sortable: true, value: 'status'},
          {text: 'CSR', align: 'start', sortable: true, value: 'dealtWithBy'},
          {text: 'CC Attempted', align: 'start', sortable: true, value: 'cca'},
          {text: 'CC Success', align: 'start', sortable: true, value: 'ccs'},
          {text: 'Signature', align: 'start', sortable: true, value: 'agreedToTerms'},
        ],
        genders: [
          {name: "None",id: 0, value: 0},
          {name: "Groom 🤵", id: 1, value: 1},
          {name: "Bride 👰", id: 2, value: 2}
        ],
        editMode: false,
        data: {
          name: "",
          location: "",
          serial: "",
          documentTypes: [],
          data: '',
          metadata: ''
        },
        allData: [],
        singular: "Appointment",
        singularLower: "appointment",
        plural: "Appointments",
        pluralLower: "appointments",

        pagination: {
          loading: false,
          dataCount: 0,
          pageSizeOptions: [5, 10, 15, 30, -1]
        },
        options: {
          search: "",
          sortBy: ['id'],
          sortDesc: [true],
          page: 1,
          itemsPerPage: 15
        },
        updatingRoute: false,
        init: false,
        appointmentSearch: "",

        createAppointmentDialog: {
          isOpen: false,
          isValid: false,
          isLoading: false,
          appointment: {
            intentions: [],
            gender: 0,
            metadata: {
              force: false,
              firstAppointment: true  
            }
          },
          exemptionLabel: ''
        },

        customers: [],
        intentions: [],
        dateSchedule: [],
        appointmentTypes: [],
        dateScheduleLoader: false,
      }
    },
    async created(){
      try{
        //used for pagination
        let oldQuery = this.getURLQuery();
        this.options.page = oldQuery.page || 1;
        this.options.itemsPerPage = oldQuery.limit || 15
        this.options.sortBy = [oldQuery.sort || "id"]
        this.options.sortDesc = [oldQuery.order || false]
        this.options.search = oldQuery.search || ""
        this.appointmentSearch = this.options.search;
        //used for pagination end
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    async mounted(){
      try {
        this.init = true;

        this.pagination.pageSizeOptions = this.getGlobalValue("paginationPageLimitsGeneral")?.split(",").map(x => parseInt(x)) || this.pagination.pageSizeOptions;

        let res = await axios.get(`${this.getEndpoint}/api/appointmentTypes`)
        if(res.data.error) throw res.data.error
        this.appointmentTypes = res.data.data

        await this.getAllData();
        this.init = false;
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getEndpoint', 'isAllowed', 'getGlobalValue', 'lookupUsername']),
    },
    watch: {
      options: {
        async handler () {
          await this.getAllData();
        },
        deep: true,
      },
      $route: {
        handler: async function (current) {
          //used for pagination
          if (this.updatingRoute) return;
          let oldQuery = this.getURLQuery(current.query);
          this.options.page = oldQuery.page || 1;
          this.options.itemsPerPage = oldQuery.limit || 15
          this.options.sortBy = [oldQuery.sort || "scheduledFor"]
          this.options.sortDesc = [oldQuery.order || false]
          this.options.search = oldQuery.search || ""
          //used for pagination end include full watcher
        },
        deep: true
      }
    },
    methods: {
      searchAppointments: _.debounce(function(){
        this.options.search = this.appointmentSearch;
        if(!this.options.search) this.options.search = "" //added in so when clearable is clicked, the table resets properly
        this.getAllData()
      }, 700),
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      clear() {
        this.$refs.signaturePad.clearSignature();
      },
      save() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if(isEmpty) return
        let w = window.open()
        w.document.write(`<img src='${data}' width="10%" />`)
      },
      getURLQuery(custom=null){
        let oldQuery = custom? {...custom}: {...this.$route.query};
        if(oldQuery.limit) oldQuery.limit = parseInt(oldQuery.limit);
        if(oldQuery.page) oldQuery.page = parseInt(oldQuery.page);
        if(oldQuery.order) oldQuery.order = oldQuery.order==='true';
        return oldQuery;
      },
      setAppointmentBlock(){
        let x = new Date(this.createAppointmentDialog.appointment.scheduledForDate)
        let h = parseInt((this.createAppointmentDialog.appointment.scheduledForTime.time).split(":")[0])
        let m = parseInt((this.createAppointmentDialog.appointment.scheduledForTime.time).split(":")[1])
        x.setUTCHours(h)
        x.setUTCMinutes(m)
        this.createAppointmentDialog.appointment.scheduledFor = x
        this.updateAppointment()
      },
      async findCustomerByPhone(){
        try {
          this.createAppointmentDialog.appointment.customerName = ""
          this.createAppointmentDialog.appointment.customerId = ""
          if(!this.createAppointmentDialog.appointment?.customerPhone){
            this.newCustomer.suggestedMatches = []
            return
          }
          if(this.createAppointmentDialog.appointment?.customerPhone?.length < 3) return
          this.findCustomerByPhoneLoader = true
          let res = await axios.get(`${this.getEndpoint}/api/customers/byPhone/${this.createAppointmentDialog.appointment.customerPhone}`)
          this.newCustomer.suggestedMatches = res.data.data
          this.findCustomerByPhoneLoader = false
          this.updateAppointment()
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error")
          this.findCustomerByPhoneLoader = false
        }
      },
      setCustomer(cust){
        this.createAppointmentDialog.appointment.customerId = cust.id;
        this.createAppointmentDialog.appointment.customerPhone = cust.phone;
        this.createAppointmentDialog.appointment.customerName = cust.firstName + " " + cust.lastName;
        this.createAppointmentDialog.appointment.customerEmail = cust.email;
        this.createAppointmentDialog.appointment.customerLine1 = cust.address?.line1||'';
        this.createAppointmentDialog.appointment.customerLine2 = cust.address?.line2||'';
        this.createAppointmentDialog.appointment.customerCity = cust.address?.city||'';
        this.newCustomer.suggestedMatches = []
        this.updateAppointment()
      },
      updateAppointment(){
        let temp = true
        if(!this.createAppointmentDialog.appointment) temp = false
        if(this.createAppointmentDialog.appointment.intentions.length < 1) temp = false
        if(!this.createAppointmentDialog.appointment.budget) temp = false
        if(!this.createAppointmentDialog.appointment.occupants) temp = false
        if(!this.createAppointmentDialog.appointment.customerName) temp = false
        if(!this.createAppointmentDialog.appointment.customerPhone) temp = false
        if(!this.createAppointmentDialog.appointment.scheduledFor) temp = false
        if(!this.createAppointmentDialog.appointment.weddingDate) temp = false
        this.createAppointmentDialog.isValid = temp
      },
      clearCustomerSuggestions(){
        this.newCustomer.suggestedMatches = []
      },
      async getDateSchedule(){
        try {
          if(!this.createAppointmentDialog.appointment.scheduledForDate) return
          
          this.createAppointmentDialog.exemptionLabel = ''
          this.dateScheduleLoader = true
          this.createAppointmentDialog.appointment.scheduledForTime = {}
          
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/byDate/${this.createAppointmentDialog.appointment.scheduledForDate}`)
          if(res.data.error) throw res.data.error
          
          let reservedBlocks = res.data.data

          this.dateSchedule = []
          let totalAvailableBlocks = (this.getGlobalValue('APPOINTMENT_AVAILABILITY_SCHEDULE'))

          let d = (new Date(this.createAppointmentDialog.appointment.scheduledForDate))
          let dayOfWeek = d.getUTCDay()
          let wordDayOfWeek = ["Sunday","Monday", "Tuesday","Wednesday", "Thursday", "Friday", "Saturday"]

          for(let block of totalAvailableBlocks.weekly[dayOfWeek]){
            for(let x = 0; x < parseInt(this.getGlobalValue('APPOINTMENTS_ALLOWED_SIMULTANEOUSLY')); x++){
              
              let isAvailable = true
              if(reservedBlocks.includes(block)){
                isAvailable = false
                reservedBlocks.splice(reservedBlocks.indexOf(block),1)
              }
              
              this.dateSchedule.push({
                block: x+1,
                dayWord: wordDayOfWeek[dayOfWeek],
                time: block,
                available: isAvailable, 
                isSelected: false
              })
            }
          }

          for(let exemption of totalAvailableBlocks.dayExemptions){
            if(exemption.repeating==="N"){ // N exemptions are non-repeating exemptions that must contain a date in the format YYYY-MM-DD
              // let splittedDate = exemption.day.split('-')
              // let formattedExemptionDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
              // console.log(formattedExemptionDate,this.createAppointmentDialog.appointment.scheduledForDate)
              if(exemption.day==this.createAppointmentDialog.appointment.scheduledForDate){
                this.createAppointmentDialog.exemptionLabel = exemption.label
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else if(exemption.repeating==="W"){ // W exemptions are weekly-repeating exemptions that must contain the day key, whose value is an int, where sunday = 0 and saturday = 6
              console.log(exemption.day,d.getUTCDay())
              if(exemption.day==d.getUTCDay()){
                this.createAppointmentDialog.exemptionLabel = exemption.label
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else if(exemption.repeating==="M"){ // M exemptions are monthly-repeating exemptions that must contain the day key, whose value is an int that corresponds to the day of the month 
              if(exemption.day==d.getUTCDate()){
                this.createAppointmentDialog.exemptionLabel = exemption.label
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else if(exemption.repeating==="Y"){ // Y exemptions are yearly-repeating exemptions that must contain the day key, whose value is a string of the format DD/MM

              let splittedDate = exemption.day.split('/')
              let selectedDateSplitted = this.createAppointmentDialog.appointment.scheduledForDate.split("-")

              let formattedExemptionDay = splittedDate[0]
              let formattedExemptionMonth = splittedDate[1]
              let selectedDateDay = selectedDateSplitted[2]
              let selectedDateMonth = selectedDateSplitted[1]

              if(formattedExemptionMonth==selectedDateMonth && formattedExemptionDay==selectedDateDay){
                this.createAppointmentDialog.exemptionLabel = exemption.label
                console.log(exemption)
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else {
              this.createAppointmentDialog.exemptionLabel = ''
            }
          }

        } catch (error) {
          console.log(error.msg || error)
          this.snack(error)
        } finally {
          this.dateScheduleLoader = false
        }
      },
      async saveAppointment(){
        try {
          this.createAppointmentDialog.isLoading = true;

          console.log(this.createAppointmentDialog.appointment)

          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.createAppointmentDialog.appointment)
          if(res.data.error) throw res.data.error;
          this.snack(`${this.singular} Created 🎉`);

          this.closeCreateAppointmentDialog();
          await this.getAllData();
        } catch (error) {
          console.log(error)          
        }finally {
          this.createAppointmentDialog.isLoading = false;
        }
      },
      rowClick(row){
        this.$router.push({ path: `/${this.pluralLower}/view/${row.id}`})
      },
      openCreateAppointmentDialog(){
        this.createAppointmentDialog.isOpen = true
      },
      closeCreateAppointmentDialog(){
        this.createAppointmentDialog = {
          isOpen: false,
          isValid: false,
          isLoading: false,
          appointment: {gender: 0, intentions: [], metadata: {force:false, firstAppointment: true}},
          exemptionLabel: ''
        }
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.data)
          if(res.data.error) throw res.data.error

          this.snack(`${this.singular} Created 🎉`, "success");

          this.data={
            name: "",
            location: "",
            serial: "",
            documentTypes: [],
            data: {},
            metadata: {}
          };
          await this.getAllData();
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        }
      },
      async getAllData(){
        try {
          //used for pagination
          this.pagination.loading = true;
          let paginationData = {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sort: (this.options.sortBy.length>0)?this.options.sortBy[0]:"id",
            order: this.options.sortDesc[0],
            search: this.options.search
          }

          let uriFields = Object.keys(paginationData).map(x => {
            return x + "=" + (paginationData[x]!==undefined?encodeURIComponent(paginationData[x]):'')
          }).join("&");
          //used for pagination end

          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/tableDataPaginated?${uriFields}`)
          if(res.data.error) throw res.data.error
          this.allData = res.data.data

          //used for pagination
          this.pagination.dataCount = res.data.total
          let shouldUpdate = false;
          let oldQuery = this.getURLQuery();
          let newQuery = {...paginationData};
          if(Object.keys(newQuery).length!==Object.keys(oldQuery).length) shouldUpdate = true;
          if(!shouldUpdate){
            for(let key of Object.keys(newQuery)){
              if(shouldUpdate) break;

              if(Array.isArray(newQuery[key])){
                if(newQuery[key].length!==oldQuery[key].length){
                  shouldUpdate = true;
                  break;
                }
                for(let i=0;i<newQuery[key].length-1;i++){
                  if(newQuery[key][i]!==oldQuery[key][i]){
                    shouldUpdate = true;
                    break;
                  }
                }
              }
              else if(newQuery[key]!==oldQuery[key]){
                shouldUpdate = true;
              }
            }
          }

          if(shouldUpdate){
            this.updatingRoute = true;
            if(this.init){
              if(this.$route.path===`/${this.pluralLower}`) await this.$router.replace({path: `/${this.pluralLower}`, query: newQuery});
            }
            else{
              if(this.$route.path===`/${this.pluralLower}`) await this.$router.push({path: `/${this.pluralLower}`, query: newQuery});
            }
            this.updatingRoute = false;
          }
          //used for pagination end
          
          res = await axios.get(`${this.getEndpoint}/api/customers`)
          if(res.data.error) throw res.data.error;
          this.customers = res.data.data;

          res = await axios.get(`${this.getEndpoint}/api/activityTypes`)
          if(res.data.error) throw res.data.error;
          this.intentions = res.data.data;
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.pagination.loading = false;
        }
      }
    },
  }
</script>
